import React from 'react';

import { ResponsiveContainer, ScatterChart, Legend, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceArea } from 'recharts';
import positiony from '../Support/Positiony';

import Tooltrip from './Tooltrip';

const positionGraph = (props) => {

	const size = +props.data.length; // Expect to be 8 or 16

	const tabs = [];
	const axis_ticks = [0.5];
	const axis_domain = [0.5, size + 0.5];

	for(let t = 1; t <= size; t++) {
		tabs.push(t);
		axis_ticks.push(t + 0.5);
	}

	const active_int = +props.activePosition;
	const active_float = parseFloat(active_int);
	const highlight_column = active_int < 0 ? false : true;
	const offer_icon = 'square';

	let tabset = tabs.map(tab => {
		const tab_index = +tab - 1;
		let tab_classes = 'position-graph__tab';
		if(active_int === tab_index) tab_classes += ' position-graph__tab--active';
		return ( 
			<li key={tab} className={tab_classes}>
				<button className='position-graph__tab__btn' onClick={() => props.selector(tab_index)}>{tab}</button>
			</li>
		);
	});

	const offersPrimeGraphData = [];
	const offersCounterGraphData = [];

	let offersPrimeScatter = null;
	let offersCounterScatter = null;

	if(props.offersPrime) {
		for(let op in props.offersPrime) {
			const prime_offer = {position: +op + 1, plaintiff: props.offersPrime[op].value, kind: 'offer', accepted: props.offersPrime[op].accepted};
			offersPrimeGraphData.push( prime_offer );
		}
		offersPrimeScatter = <Scatter yAxisId="left" name='Offer' line data={offersPrimeGraphData} fill='#ffac96'
								strokeWidth={2} shape={(props) => graphoffer(props,'#ffac96')} legendType={offer_icon} />;
	}

	if(props.offersCounter) {
		for(let oc in props.offersCounter) {
			const counter_offer = {position: +oc + 1, plaintiff: props.offersCounter[oc].value, kind: 'counter', accepted: props.offersCounter[oc].accepted};
			offersCounterGraphData.push( counter_offer );
		}
		offersCounterScatter = <Scatter yAxisId="left" name='Counter Offer' line data={offersCounterGraphData} fill='#60b5c7'
        						strokeWidth={2} shape={(props) => graphoffer(props,'#60b5c7')} legendType={offer_icon} unit='offer' />;
	}

	let axis_font = 8;
	if(window.outerWidth >= 320) {
		axis_font = 9;
		if(window.outerWidth >= 480) {
			axis_font = 10;
			if(window.outerWidth >= 640) {
				axis_font = 11;
			}
		}
	}

	return (
		<div className='position-graph'>

			<div className='position-graph__hero'>
				<h5 className='position-graph__axial position-graph__axial--left'>Plaintiff's Position ($)</h5>
				<h5 className='position-graph__axial position-graph__axial--right'>Defendant's Position ($)</h5>

				<div className='position-graph__container'>
					<ResponsiveContainer>
						<ScatterChart onClick={(event) => event ? props.selector( Math.floor(event.xValue - 0.5) ) : null}>
							<ReferenceArea alwaysShow={highlight_column} yAxisId="left"
								x1={active_float + 0.5} x2={active_float + 1.5} fill="#f1efea" />
							<Legend verticalAlign="top" height={36} iconSize={12} />
							<CartesianGrid />
							<XAxis
								tickFormatter={(value) => ''} type="number" interval={0} height={10}
								tickCount={axis_ticks.length} allowDecimals={true} ticks={axis_ticks}
								dataKey="position" domain={axis_domain} stroke="#77777a" />
							<YAxis
								tickFormatter={(value) => positiony(value).toString()}
								tick={{fontSize: axis_font+'px', fontWeight: 'bold'}}
								yAxisId="left" type="number" dataKey="plaintiff"
								name='Plaintiff' stroke="#77777a" />
							<YAxis
								tickFormatter={(value) => positiony(value).toString()}
								tick={{fontSize: axis_font+'px', fontWeight: 'bold'}}
								yAxisId="right" orientation="right" type="number"
								dataKey="defendant" name='Defendant' stroke="#77777a" />
							<Tooltip content={<Tooltrip/>} />
							{offersPrimeScatter}
        					{offersCounterScatter}
        					<Scatter yAxisId="left" name='Plaintiff' line data={props.data} fill="#f55c34" strokeWidth={2}
								legendType='line' shape={(props) => graphdot(props,active_int,'#f55c34')} activeDot={{strokeWidth: 0, r: 7}}/>
        					<Scatter yAxisId="right" name='Defendant' line data={props.data} fill="#2f8294" strokeWidth={2}
							 	legendType='line' shape={(props) => graphdot(props,active_int,'#2f8294')} activeDot={{strokeWidth: 0, r: 7}} />
						</ScatterChart>
					</ResponsiveContainer>
				</div>

			</div>

			<div className='position-graph__tabs screen-only'>
				<ul className='position-graph__tab-list'>
					{tabset}
				</ul>
				<h4 className='position-graph__tabs__heading'>Category</h4>
			</div>

		</div>
	);
}

/* <ul className='print print--graph-categories'>
	{tabset}
</ul> */

export default positionGraph;


const graphdot = (props,active_int,colour) => {
	active_int += 1;
	const set_r = (+props.position === active_int) ? 7 : 5;
	const set_wd = (+props.position === active_int) ? 0 : 2;
	const clr = colour ? colour : '#2f8294';
	const set_fill = (+props.position === active_int) ? clr : '#fff';
	return <circle key={props.key} r={set_r} stroke={clr} strokeWidth={set_wd}
			fill={set_fill} width={props.width} height={props.height}
			className="recharts-dot recharts-line-dot" cx={props.cx} cy={props.cy} />
}


const graphoffer = (props,colour) => {
	const clr = colour ? colour: '#ffac96';
	if(props.accepted) {
		return <path fill={clr} className="recharts-symbols" transform={'translate(' + (+props.x + 5) + ', ' + (+props.y + 5) + ')'}
				width="2" height="2" strokeWidth="1" x={props.x} y={props.y}
				d="M0,-16.82339558781227L3.7770876399966338,-5.1987151397265L15.999999999999995,-5.198715139726501L6.111456180001681,1.9857324855468637L9.888543819998317,13.610412933632634L8.881784197001252e-16,6.42596530835927L-9.888543819998313,13.610412933632636L-6.11145618000168,1.985732485546865L-15.999999999999998,-5.198715139726497L-3.777087639996635,-5.198715139726499Z" />;
	}
	return <path key={props.key} fill={clr} width="5" height="5" className="recharts-symbols"
			strokeWidth="1" x={props.x} y={props.y} d="M-4,-4h8v8h-8Z"
			transform={'translate(' + (+props.x + 5) + ', ' + (+props.y + 5) + ')'} />
}


// WEBPACK FOOTER //
// ./src/Blocks/PositionGraph.js